TODO:This needs to be abstracted - right now it is tied way to closely to PD
<template>
   <div :class="['audio-wrapper']" :id="`pd-audio-card-${card.id}`">
      <div
         :class="['audio-player', 'no-print', { muted }]"
         :id="`player-${card?.audio?.id ?? card.id}`"
      >
         <div class="audio-bar" contenteditable="false">
            <div :class="['audio-controls', 'audio-controls-play-pause']">
               <IconPause
                  v-show="playing"
                  :class="['control-pause', 'control-btn']"
                  alt="Pause"
               />
               <IconPlay
                  v-show="!playing"
                  :class="['control-play', 'control-btn']"
                  alt="Play"
               />
            </div>
            <div class="audio-meta">
               <span class="audio-time">0:00/0:00</span>
            </div>
            <div class="audio-progress">
               <progress class="audio-progress-bar" value="0" min="0" max="100">
                  progress
               </progress>
               <progress
                  class="audio-progress-buffer"
                  value="0"
                  min="0"
                  max="100"
               >
                  buffer
               </progress>
            </div>
            <div class="audio-controls audio-controls-play-pause">
               <IconMuted
                  v-show="muted"
                  :class="['control-mute', 'control-btn']"
                  alt="muted"
               />
               <IconAudio
                  v-show="!muted"
                  :class="['control-sound', 'control-btn']"
                  alt="sound"
               />
            </div>
            <audio
               class="audio-player-file"
               autobuffer
               :data-ref="`player-${card?.audio?.id ?? card.id}`"
            >
               <source :src="card?.audio?.url ?? card.src" />
               Your browser does not support the audio tag.
            </audio>
         </div>
         <div v-if="!hideTitle" class="audio-title">
            <h4 class="bold sans">{{ card?.audio?.name ?? card?.name }}</h4>
         </div>
      </div>
   </div>
</template>

<script setup lang="ts">
import IconPlay from "~/assets/images/icons/alt-play-filled.svg";
import IconPause from "~/assets/images/icons/alt-pause-filled.svg";
import IconMuted from "~/assets/images/icons/alt-mute-filled.svg";
import IconAudio from "~/assets/images/icons/alt-audio-filled.svg";

const { initPlayer, playing, muted } = useAudioPlayer();

const { card } = defineProps({
   card: { type: Object, default: () => {} },
   hideTitle: { type: Boolean, default: false },
});

onMounted(() => {
   // TODO: Clean this up so its not 3 different optons for src
   initPlayer &&
      initPlayer(
         card?.audio?.url ?? card?.audio?.src ?? card.src,
         `player-${card?.audio?.id ?? card?.id}`
      );
});
</script>
<style lang="scss" scoped>
@import "~/assets/scss/globals/audio-player";
div.audio-wrapper {
   width: 100%;
}
</style>
